/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberWithdrawSavingsInputDto { 
    savingAccountId: number;
    amount: number;
    description?: string | null;
    paymentTransactionModeId: number;
    paymentProviderId: string;
    paymentProviderWalletId?: string | null;
    paymentProviderName?: string | null;
    destinationTypeId?: number;
    memberBankId?: number | null;
    memberMnoId?: number | null;
    otp?: string | null;
}

